import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PacmanLoader from 'react-spinners/PacmanLoader';
import styles from './Home.module.css';
import Grafico from '../Grafico/Grafico';
import { FaLaptopCode, FaTools, FaSearch, FaCalendarAlt } from 'react-icons/fa';

const Home = () => {
    const usuario = useSelector(state => state.usuario);
    const nombre = usuario.usuario?.nombre || "Invitado";
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setTimeout(() => {
            setLoading(false);
        }, 2000);
    }, []);

    return (
        <div className={styles.container}>
            {loading ? (
                <div className={styles.spinnerContainer}>
                    <PacmanLoader color="#3b82f6" loading={loading} size={40} />
                </div>
            ) : (
                <div className={styles.homeContent}>
                    <header className={styles.hero}>
                        <div className={styles.heroOverlay}></div>
                        <div className={styles.heroText}>
                            <h1>Hola, {nombre}! 👋</h1>
                            <p>Bienvenido de nuevo a SIGESTIC. ¿En qué podemos ayudarte hoy?</p>
                        </div>
                    </header>

                    <div className={styles.dashboardGrid}>
                        <div className={styles.statsCard}>
                            <Grafico />
                        </div>

                        <div className={styles.quickActions}>
                            <h3 className={styles.sectionTitle}>Accesos Rápidos</h3>
                            <div className={styles.actionGrid}>
                                <div className={styles.actionCard} onClick={() => window.location.href = '/generar-ticket'}>
                                    <div className={`${styles.actionIcon} ${styles.blue}`}>
                                        <FaLaptopCode />
                                    </div>
                                    <h4>Gestión TI</h4>
                                    <p>Reporta fallas técnicas</p>
                                </div>
                                <div className={styles.actionCard} onClick={() => window.location.href = '/generar-ticketmto'}>
                                    <div className={`${styles.actionIcon} ${styles.orange}`}>
                                        <FaTools />
                                    </div>
                                    <h4>Mantenimiento</h4>
                                    <p>Solicita soporte físico</p>
                                </div>
                                <div className={styles.actionCard} onClick={() => window.location.href = '/seguimiento-ticket'}>
                                    <div className={`${styles.actionIcon} ${styles.purple}`}>
                                        <FaSearch />
                                    </div>
                                    <h4>Seguimiento</h4>
                                    <p>Estado de tus tickets</p>
                                </div>
                                <div className={styles.actionCard} onClick={() => window.location.href = '/agendamiento'}>
                                    <div className={`${styles.actionIcon} ${styles.green}`}>
                                        <FaCalendarAlt />
                                    </div>
                                    <h4>Salas</h4>
                                    <p>Reserva espacios</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Home;
